import { useContext } from "react";
import { ISpfxComponentUser } from "@excentone/spfx-core-lib";
import { UserIdentityContext } from "./UserIdentityContext.types";

export const createUseUserIdentityContext = <TUser extends ISpfxComponentUser>(context: UserIdentityContext<TUser>) => {
  const useUserIdentity = () => useContext(context);
  return useUserIdentity;
};